import styled, { css } from 'styled-components';

const applyFixedRatio = ({ratio}) => {
  const percentage = Math.round(ratio * 10000) / 100;
  return css`
    position: relative;
    padding-top: ${percentage}%;
  `;
}

const applyContentPosition = () => {
  return css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `;
}

export const Ratio = styled.div`
  ${applyFixedRatio};
`;

export const RatioContent = styled.div`
  ${applyContentPosition};
`;



// WEBPACK FOOTER //
// ./src/elements/util/FixedRatio/styled.js